<div class="main-content">
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col-md-12">
        <!-- <div class="card">
          <div class="card-header card-header-lavuro"> -->
        <span class="pull-left">
          <h2 class="text-purple-manax m-0 pl-3 title-section">Fichajes</h2>
        </span>
        <span class="pull-right pt-1 pb-4">
          <button (click)="openHelpVideoModal()" class="btn btn-outline-manax p-2 mr-3">
            <i class="material-icons align-middle">play_circle</i> Tutorial
          </button>
        </span>
        <!--button mat-raised-button type="button" class="btn btn-lavuro p-2" (click)="openNewTimeTrackModal()"> 
                <i class="material-icons">add</i> Nuevo
              </button-->

        <table class="table table-hover m-0 align-top" matSort (matSortChange)="sortTimeTracks($event)" stickyHeader
          stickyFooter>

          <thead class="text-lavuro">
            <tr>

              <!-- All -->
              <th class="d-none d-md-table-cell p-0 pl-2">
                <div class="form-check m-0 mx-2">
                  <label class="form-check-label">
                    <input class="form-check-input input-sm" type="checkbox" (click)="toggleSelection()"
                      [checked]="selection.all">
                    <span class="form-check-sign">
                      <span class="check"></span>
                    </span>
                  </label>
                </div>
              </th>

              <!-- PC -->
              <th class="d-none d-md-table-cell align-top">
                Cliente<br>
                <input type="text" class="filter small" [(ngModel)]="filter.filters.client"
                  placeholder="Buscar por Cliente…" (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()" style="max-width: 500px;" />
              </th>
              <th class="d-none d-md-table-cell align-top">
                Trabajo<br>
                <input type="text" class="filter small" [(ngModel)]="filter.filters.task"
                  placeholder="Buscar por Trabajo…" (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()" style="max-width: 500px;" />
              </th>
              <th class="d-none d-md-table-cell align-top">
                Trabajador<br>
                <input type="text" class="filter small" [(ngModel)]="filter.filters.worker"
                  placeholder="Buscar por Trabajador…" (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()" style="max-width: 250px;" />
              </th>
              <th class="d-none d-md-table-cell align-top">
                Programado<br>
                <input type="date" class="filter small" [(ngModel)]="selectedDay" (ngModelChange)="selectedDayChange()"
                  (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()"
                  style="max-width: 120px; " />
              </th>
              <th class="d-table-cell d-md-none align-top">
                Fecha<br>
                <input type="date" class="filter small" [(ngModel)]="selectedDay" (ngModelChange)="selectedDayChange()"
                  (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()"
                  style="max-width: 120px; " />
              </th>
              <th class="d-none d-md-table-cell align-top">
                Fichajes<br>
              </th>
              <th class="d-none d-md-table-cell align-top">
                Descanso<br>
              </th>
              <th class="d-none d-md-table-cell align-top">
                Detalles
              </th>

              <!-- Mobile -->
              <!--th class="d-table-cell d-md-none">
                      Orden por: <span class="ml-2">{{sortOptions[filter.sort] || 'ninguno'}}</span>
                      <span class="text-lavuro pull-right cursor-pointer" *ngIf="filtered"> - Filtrada - </span>
                    </th-->

              <!-- All -->
              <th class="d-none d-md-table-cell td-actions text-right p-0">
                <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                  [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                  <i class="material-icons">more_vert</i>
                </button>
                <mat-menu #menu="matMenu">

                  <!-- sort order -->
                  <!-- <button mat-menu-item class="d-block d-md-none" [matMenuTriggerFor]="order">
                          <span>Orden</span>
                        </button> -->

                  <!-- filters -->
                  <!--button mat-menu-item class="d-block d-md-none" (click)="openFilter()">
                          <span>Filtros</span>
                        </button-->
                  <!-- <button mat-menu-item (click)="clearFilter()">
                          <span>Limpiar Filtros</span>
                        </button> -->
                  <button mat-menu-item (click)="completeClockInOutSelectedConfirm()">
                    <span>Completar Fichajes</span>
                  </button>
                </mat-menu>

                <mat-menu #order="matMenu">
                  <ng-container *ngFor="let key of sortOptionsKeys">
                    <button mat-menu-item (click)="sortTimeTracks(key)">
                      <span>{{sortOptions[key]}}</span>
                    </button>
                  </ng-container>
                  <button mat-menu-item (click)="sortTimeTracks('')">
                    <span>Sin Ordenar</span>
                  </button>
                </mat-menu>
              </th>
            </tr>
          </thead>

          <tbody>
            <!-- default: future tasks, past or current with tracking ok -->
            <!-- primary: past with tracking null or delayed, or current with tracking delayed -->
            <!-- danger: current with tracking null -->
            <ng-container *ngFor="let timeTrack of timeTracks">

              <tr class='cursor-pointer'
                *ngIf="(!withClockIn || (withClockIn=='yes' && timeTrack.timetracks?.clockIn) || (withClockIn=='no' && !timeTrack.timetracks?.clockIn)) && 
                        (!withClockOut || (withClockOut=='yes' && timeTrack.timetracks?.clockOut) || (withClockOut=='no' && !timeTrack.timetracks?.clockOut))">
                <!--
                    [class.text-default]="(timeTrack.scheduledStart > currentDateTime) || (timeTrack.scheduledStart > timeTrack.timetracks?.clockIn)"
                    [class.text-primary]="(timeTrack.scheduledStart < currentDateTime) && (timeTrack.scheduledStart < timeTrack.timetracks?.clockIn || !(timeTrack.timetracks?.clockIn))"
                    [class.text-danger]="((timeTrack.scheduledStart < currentDateTime) && (timeTrack.scheduledEnd > currentDateTime)) && !(timeTrack.timetracks?.clockIn)"
                    -->

                <!-- All -->
                <td class="d-none d-md-table-cell p-2 align-top" (click)="$event.stopPropagation();">
                  <div class="form-check m-0 mt-1 mx-2">
                    <label class="form-check-label">
                      <input class="form-check-input input-sm" type="checkbox"
                        (click)="toggleSelection(timeTrack._id + '-' + timeTrack.worker?._id)"
                        [checked]="selection.all || selection[timeTrack._id + '-' + timeTrack.worker?._id]">
                      <span class="form-check-sign">
                        <span class="check"></span>
                      </span>
                    </label>
                  </div>
                </td>

                <!-- PC -->
                <td class="d-none d-md-table-cell field-container align-top"
                  (click)="timeTrack.client ? openClientModal(timeTrack.client) : null">
                  <b class="bold-item">{{timeTrack.client?.firstname}} {{timeTrack.client?.lastname}}</b>
                  <span class="field-actions">
                    <button mat-button type="button" class="btn text-lavuro btn-link p-1 inline-icon">
                      <i class="material-icons">launch</i>
                    </button>
                  </span>
                </td>
                <td class="d-none d-md-table-cell field-container align-top"
                  (click)="openTaskModal({_id: timeTrack._id})">
                  {{timeTrack.title}}
                  <span class="field-actions">
                    <button mat-button type="button" class="btn text-lavuro btn-link p-1 inline-icon">
                      <i class="material-icons">launch</i>
                    </button>
                  </span>
                </td>
                <td class="d-none d-md-table-cell field-container align-top"
                  (click)="timeTrack.worker ? openWorkerModal(timeTrack.worker) : null">
                  <b class="bold-item">{{timeTrack.worker?.firstname}} {{timeTrack.worker?.lastname}}</b>
                  <span class="field-actions">
                    <button mat-button type="button" class="btn btn-link text-success mx-0 p-1 inline-icon"
                      (click)="$event.stopPropagation();openWorkerWhatsapp(timeTrack.worker?.['_id'])">
                      <i class="fa fa-whatsapp mr-1"></i>
                    </button>
                    <button mat-button type="button" class="btn text-lavuro btn-link p-1 inline-icon">
                      <i class="material-icons">launch</i>
                    </button>
                  </span>
                </td>

                <td class="d-none d-md-table-cell align-top">{{timeTrack.scheduledStart | date:'HH:mm'}} ->
                  {{timeTrack.scheduledEnd | date:'HH:mm'}}</td>

                <!-- clockIn/Out -->
                <td class="d-none d-md-table-cell field-container align-top">
                  <ng-container *ngFor="let tt of timeTrack.timetracks; let i = index">
                    <ng-container *ngIf="isSameDate(tt?.datetime, selectedDay) && tt.type == 'IN'">
                      <span (click)="openEditTimeTrackModal(timeTrack , tt?._id)" class="cursor-pointer">
                        {{tt.datetime | date:'HH:mm'}} ->
                      </span>
                    </ng-container>
                    <ng-container *ngIf="tt.type == 'OUT' && previousIsSameDate(timeTrack, i)">
                      <span (click)="openEditTimeTrackModal(timeTrack, tt?._id)" class="cursor-pointer">
                        {{tt.datetime | date:'HH:mm'}}
                      </span>
                      <br>
                    </ng-container>
                  </ng-container>
                  <span (click)="openTimeTrackModal(timeTrack)"
                    *ngIf="(timeTrack.timetracks.length == 0 || timeTrack.timetracks[timeTrack.timetracks.length - 1].type == 'OUT')">
                    <i class="material-icons text-lavuro inline-icon">add_circle</i>
                  </span>
                  <span
                    (click)="openEditTimeTrackModal(timeTrack, timeTrack.timetracks[timeTrack.timetracks.length - 1]._id)"
                    *ngIf="!(timeTrack.timetracks.length == 0 || timeTrack.timetracks[timeTrack.timetracks.length - 1].type == 'OUT')">
                    <i class="material-icons text-lavuro inline-icon">add_circle</i>
                  </span>
                </td>

                <!-- Breaks -->
                <td class="d-none d-md-table-cell field-container align-top">
                  <span *ngFor="let timeT of timeTrack.groupedData">
                    <div *ngIf="isSameDate(timeT.entrada?.datetime, selectedDay)">
                      <div *ngIf="timeT.pauseInProgress === true"
                        (click)="openEditTimeTrackModal(timeTrack, timeT?.entrada?._id, true)">
                        EN CURSO
                      </div>
                      <div *ngIf="timeT.totalPauseTime <= 0">
                        <br>
                      </div>
                      <div *ngIf="timeT.totalPauseTime > 0 && timeT.pauseInProgress === false"
                        (click)="openEditTimeTrackModal(timeTrack, timeT?.pausas[0]?.pausa?._id, true)">
                        {{timeT?.totalPauseTime}} min
                      </div>
                    </div>
                  </span>
                </td>
                <!-- <td class="d-none d-md-table-cell field-container align-top text-right">
                  {{timeTrack.totalBreakTime}} min
                </td> -->

                <!-- icon -->
                <td class="d-none d-md-table-cell">
                  <ng-container *ngFor="let tt of timeTrack.timetracks; let i = index">
                    <ng-container *ngIf="isSameDate(tt?.datetime, selectedDay) && tt.type == 'IN'">
                      <span *ngIf="tt?.origin == 'admin'" (click)="openEditTimeTrackModal(timeTrack, tt?._id)">
                        <i class="material-icons text-lavuro" [matTooltip]="'Registrado por administrador'"
                          style="cursor: default">laptop</i>
                      </span>
                      <span *ngIf="(tt?.origin !== 'admin' && tt?.location?.length === 0)"
                        (click)="openEditTimeTrackModal(timeTrack, tt?._id)">
                        <i class="material-icons" style="color: #666666;" [matTooltip]="'Sin ubicación registrada'"
                          style="cursor: default">location_off</i>
                      </span>
                      <span *ngIf="(tt?.origin !== 'admin' && tt?.outOfRange === false && tt?.location?.length > 0)"
                        (click)="openEditTimeTrackModal(timeTrack, tt?._id)">
                        <i class="material-icons text-success" [matTooltip]="'Fichaje dentro de rango'">place</i>
                      </span>
                      <span *ngIf="(tt?.origin !== 'admin' && tt?.outOfRange === true && tt?.location?.length > 0)"
                        (click)="openEditTimeTrackModal(timeTrack, tt?._id)">
                        <i class="material-icons text-danger" [matTooltip]="'Fichaje fuera de rango'">wrong_location</i>
                      </span>
                    </ng-container>
                    <ng-container *ngIf="tt.type == 'OUT' && previousIsSameDate(timeTrack, i)">
                      <span *ngIf="tt?.origin == 'admin'" (click)="openEditTimeTrackModal(timeTrack, tt?._id)">
                        <i class="material-icons text-lavuro" [matTooltip]="'Registrado por administrador'"
                          style="cursor: default">laptop</i>
                      </span>
                      <span *ngIf="(tt?.origin !== 'admin' && tt?.location?.length === 0)"
                        (click)="openEditTimeTrackModal(timeTrack, tt?._id)">
                        <i class="material-icons" style="color: #666666;" [matTooltip]="'Sin ubicación registrada'"
                          style="cursor: default">location_off</i>
                      </span>
                      <span *ngIf="(tt?.origin !== 'admin' && tt?.outOfRange === false && tt?.location?.length > 0)"
                        (click)="openEditTimeTrackModal(timeTrack, tt?._id)">
                        <i class="material-icons text-success" [matTooltip]="'Fichaje dentro de rango'">place</i>
                      </span>
                      <span *ngIf="(tt?.origin !== 'admin' && tt?.outOfRange === true && tt?.location?.length > 0)"
                        (click)="openEditTimeTrackModal(timeTrack, tt?._id)">
                        <i class="material-icons text-danger" [matTooltip]="'Fichaje fuera de rango'">wrong_location</i>
                      </span>
                      <br>
                    </ng-container>
                  </ng-container>
                </td>

                <!-- Mobile -->
                <td class="d-table-cell d-md-none" style="line-height: 14px;">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-12">
                        <div class="row mb-2 pr-3">
                          <b class="bold-item">
                            {{timeTrack.title}}
                          </b>
                        </div>
                        <div class="row mb-2 pr-3">
                          {{timeTrack.client?.firstname}} {{timeTrack.client?.lastname}}
                        </div>
                        <div class="row mb-2 pr-3">
                          Hora: {{timeTrack.scheduledStart | date:'HH:mm'}} -> {{timeTrack.scheduledEnd | date:'HH:mm'}}
                        </div>
                        <div class="row mb-2 pr-3">
                          Trabajador: {{timeTrack.worker?.firstname}} {{timeTrack.worker?.lastname}}
                        </div>

                        <!-- <div class="row mb-2 pr-3" *ngIf="timeTrack?.totalBreakTime >= 1" >
                          Tiempo Total Descansado: {{formatTime(timeTrack?.totalBreakTime)}}
                        </div> -->

                        <!-- <div class="row mb-2 pr-3 field-container align-top"> -->
                        <ng-container *ngFor="let tt of timeTrack.timetracks; let i = index">
                          <div class="row mb-2 pr-3"
                            *ngIf="isSameDate(tt?.datetime, selectedDay) && tt.type !== 'PAUSE' && tt.type !== 'RESUME'">
                            <ng-container *ngIf="isSameDate(tt?.datetime, selectedDay) && tt.type == 'IN'">
                              <div style="width: 100% !important; border-top: #c0c1c2 solid 1px; padding: 2px 0px;">
                              </div>
                              <div class="d-flex justify-content-between align-items-center"
                                style="width: 100% !important;">
                                <div (click)="openEditTimeTrackModal(timeTrack, tt?._id)" class="cursor-pointer">
                                  Entrada: {{tt.datetime | date:'HH:mm'}}
                                </div>
                                <div>
                                  <span *ngIf="tt?.origin == 'admin'"
                                    (click)="openEditTimeTrackModal(timeTrack, tt?._id)">
                                    <i class="material-icons text-lavuro" [matTooltip]="'Registrado por administrador'"
                                      style="cursor: default">laptop</i>
                                  </span>
                                  <span *ngIf="(tt?.origin !== 'admin' && tt?.location?.length === 0)"
                                    (click)="openEditTimeTrackModal(timeTrack, tt?._id)">
                                    <i class="material-icons" style="color: #666666;"
                                      [matTooltip]="'Sin ubicación registrada'" style="cursor: default">location_off</i>
                                  </span>
                                  <span
                                    *ngIf="(tt?.origin !== 'admin' && tt?.outOfRange === false && tt?.location?.length > 0)"
                                    (click)="openEditTimeTrackModal(timeTrack, tt?._id)">
                                    <i class="material-icons text-success"
                                      [matTooltip]="'Fichaje dentro de rango'">place</i>
                                  </span>
                                  <span
                                    *ngIf="(tt?.origin !== 'admin' && tt?.outOfRange === true && tt?.location?.length > 0)"
                                    (click)="openEditTimeTrackModal(timeTrack, tt?._id)">
                                    <i class="material-icons text-danger"
                                      [matTooltip]="'Fichaje fuera de rango'">wrong_location</i>
                                  </span>
                                </div>
                              </div>
                            </ng-container>

                            <ng-container *ngIf="tt.type == 'OUT' && previousIsSameDate(timeTrack, i)">
                              <div class="d-flex justify-content-between align-items-center"
                                style="width: 100% !important;">
                                <div (click)="openEditTimeTrackModal(timeTrack, tt?._id)" class="cursor-pointer">
                                  Salida: {{tt.datetime | date:'HH:mm'}}
                                </div>
                                <div>
                                  <span *ngIf="tt?.origin == 'admin'"
                                    (click)="openEditTimeTrackModal(timeTrack, tt?._id)">
                                    <i class="material-icons text-lavuro" [matTooltip]="'Registrado por administrador'"
                                      style="cursor: default">laptop</i>
                                  </span>
                                  <span *ngIf="(tt?.origin !== 'admin' && tt?.location?.length === 0)"
                                    (click)="openEditTimeTrackModal(timeTrack, tt?._id)">
                                    <i class="material-icons" style="color: #666666;"
                                      [matTooltip]="'Sin ubicación registrada'" style="cursor: default">location_off</i>
                                  </span>
                                  <span
                                    *ngIf="(tt?.origin !== 'admin' && tt?.outOfRange === false && tt?.location?.length > 0)"
                                    (click)="openEditTimeTrackModal(timeTrack, tt?._id)">
                                    <i class="material-icons text-success"
                                      [matTooltip]="'Fichaje dentro de rango'">place</i>
                                  </span>
                                  <span
                                    *ngIf="(tt?.origin !== 'admin' && tt?.outOfRange === true && tt?.location?.length > 0)"
                                    (click)="openEditTimeTrackModal(timeTrack, tt?._id)">
                                    <i class="material-icons text-danger"
                                      [matTooltip]="'Fichaje fuera de rango'">wrong_location</i>
                                  </span>
                                </div>
                              </div>
                            </ng-container>
                          </div>
                        </ng-container>

                        <div (click)="openTimeTrackModal(timeTrack)"
                          *ngIf="(timeTrack.timetracks.length == 0 || timeTrack.timetracks[timeTrack.timetracks.length - 1].type == 'OUT')">
                          <i class="material-icons text-lavuro inline-icon">add_circle</i>
                        </div>
                        <div
                          (click)="openEditTimeTrackModal(timeTrack, timeTrack.timetracks[timeTrack.timetracks.length - 1]._id)"
                          *ngIf="!(timeTrack.timetracks.length == 0 || timeTrack.timetracks[timeTrack.timetracks.length - 1].type == 'OUT')">
                          <i class="material-icons text-lavuro inline-icon">add_circle</i>
                        </div>

                        <!-- </div> -->


                        <!-- <div class="row mb-2 pr-3">
                          <span class="cursor-pointer p-0 m-0" (click)="openNewTimeTrackModal(timeTrack)">
                            Entrada: {{timeTrack.timetracks?.clockIn | date:'HH:mm:ss'}}
                            <button mat-button type="button" class="btn text-manax btn-link p-0 m-0 inline-icon"
                              *ngIf="timeTrack.timetracks?.clockIn">
                              <i class="material-icons">edit</i>
                            </button>
                            <button mat-button type="button" class="btn btn-manax btn-link p-0 m-0 inline-icon"
                              *ngIf="!timeTrack.timetracks?.clockIn"
                              style="border: 1px solid #4B39EF; padding: .2px 5px !important;">
                              <i class=" material-icons">add</i> Agregar
                            </button>
                          </span>
                        </div>
                        <div class="row pr-3">
                          <span class="cursor-pointer p-0 m-0" (click)="openNewTimeTrackModal(timeTrack)">
                            Salida: {{timeTrack.timetracks?.clockOut | date:'HH:mm:ss'}}
                            <button mat-button type="button" class="btn text-manax btn-link p-0 m-0 inline-icon"
                              *ngIf="timeTrack.timetracks?.clockOut">
                              <i class="material-icons">edit</i>
                            </button>
                            <button mat-button type="button" class="btn btn-manax btn-link p-0 m-0 inline-icon"
                              *ngIf="!timeTrack.timetracks?.clockOut"
                              style="border: 1px solid #4B39EF; padding: .2px 5px !important;">
                              <i class=" material-icons">add</i> Agregar
                            </button>
                          </span><br>
                        </div> -->
                      </div>
                      <!-- <div class="col-2 d-flex flex-column align-items-center justify-content-center p-0"> -->
                      <!-- <div class="row mb-2">
                          <span style="white-space: nowrap;">
                            <ng-container
                              *ngIf="(!(timeTrack.timetracks?.origin === 'admin') && timeTrack.timetracks && ((timeTrack.timetracks?.clockIn && timeTrack.timetracks?.locationIn?.length <= 0) || (timeTrack.timetracks?.clockOut && timeTrack.timetracks?.locationOut?.length <= 0)))">
                              <i class="material-icons" style="color: #666666;"
                                [matTooltip]="'Sin ubicación registrada'" style="cursor: default">location_off</i>
                            </ng-container>
                            <ng-container
                              *ngIf="(((!timeTrack.outOfRangeIn && (timeTrack.timetracks?.locationIn?.length > 0)) || (!timeTrack.outOfRangeOut && (timeTrack.timetracks?.locationOut?.length > 0))) )">
                              <i class="material-icons text-success" [matTooltip]="'Fichaje dentro de rango'"
                                (click)="openNewTimeTrackModal(timeTrack)">place</i>
                            </ng-container>
                            <ng-container *ngIf="timeTrack.outOfRangeIn || timeTrack.outOfRangeOut">
                              <i class="material-icons text-danger" [matTooltip]="'Fichaje fuera de rango'"
                                (click)="openNewTimeTrackModal(timeTrack)">wrong_location</i>
                            </ng-container>
                            <ng-container *ngIf="timeTrack.timetracks?.origin == 'admin'">
                              <i class="material-icons text-lavuro" [matTooltip]="'Registrado por administrador'"
                                style="cursor: default">laptop</i>
                            </ng-container>
                            <ng-container *ngIf="timeTrack.comments > 0">
                              <i class="material-icons text-manax" [matTooltip]="'Se cargaron fotos o notas'"
                                (click)="openTaskModal({_id: timeTrack._id}, true)" style="cursor: pointer">forum</i>
                            </ng-container>
                          </span>
                        </div> -->

                      <!-- <div class="row mb-2 pr-3">
                        </div>
                        <div class="row mb-2 pr-3">
                          
                        </div>
                        <div class="row mb-2 pr-3">
                        
                        </div>
                        <div class="row mb-2 pr-3">
                          
                        </div>

                        <ng-container *ngFor="let tt of timeTrack.timetracks; let i = index">
                          <div class="row mb-2 pr-3">

                            <ng-container *ngIf="isSameDate(tt?.datetime, selectedDay) && tt.type == 'IN'">
                              <span *ngIf="tt?.origin == 'admin'" (click)="openEditTimeTrackModal(timeTrack, i)">
                                <i class="material-icons text-lavuro" [matTooltip]="'Registrado por administrador'"
                                  style="cursor: default">laptop</i>
                              </span>
                              <span *ngIf="(tt?.origin !== 'admin' && tt?.location?.length === 0)"
                                (click)="openEditTimeTrackModal(timeTrack, i)">
                                <i class="material-icons" style="color: #666666;"
                                  [matTooltip]="'Sin ubicación registrada'" style="cursor: default">location_off</i>
                              </span>
                              <span
                                *ngIf="(tt?.origin !== 'admin' && tt?.outOfRange === false && tt?.location?.length > 0)"
                                (click)="openEditTimeTrackModal(timeTrack, i)">
                                <i class="material-icons text-success"
                                  [matTooltip]="'Fichaje dentro de rango'">place</i>
                              </span>
                              <span
                                *ngIf="(tt?.origin !== 'admin' && tt?.outOfRange === true && tt?.location?.length > 0)"
                                (click)="openEditTimeTrackModal(timeTrack, i)">
                                <i class="material-icons text-danger"
                                  [matTooltip]="'Fichaje fuera de rango'">wrong_location</i>
                              </span>
                            </ng-container>
                            <ng-container *ngIf="tt.type == 'OUT' && previousIsSameDate(timeTrack, i)">
                              <span *ngIf="tt?.origin == 'admin'" (click)="openEditTimeTrackModal(timeTrack, i)">
                                <i class="material-icons text-lavuro" [matTooltip]="'Registrado por administrador'"
                                  style="cursor: default">laptop</i>
                              </span>
                              <span *ngIf="(tt?.origin !== 'admin' && tt?.location?.length === 0)"
                                (click)="openEditTimeTrackModal(timeTrack, i)">
                                <i class="material-icons" style="color: #666666;"
                                  [matTooltip]="'Sin ubicación registrada'" style="cursor: default">location_off</i>
                              </span>
                              <span
                                *ngIf="(tt?.origin !== 'admin' && tt?.outOfRange === false && tt?.location?.length > 0)"
                                (click)="openEditTimeTrackModal(timeTrack, i)">
                                <i class="material-icons text-success"
                                  [matTooltip]="'Fichaje dentro de rango'">place</i>
                              </span>
                              <span
                                *ngIf="(tt?.origin !== 'admin' && tt?.outOfRange === true && tt?.location?.length > 0)"
                                (click)="openEditTimeTrackModal(timeTrack, i)">
                                <i class="material-icons text-danger"
                                  [matTooltip]="'Fichaje fuera de rango'">wrong_location</i>
                              </span>
                              <br>
                            </ng-container>
                          </div>
                        </ng-container> -->
                      <!-- </div> -->
                    </div>
                  </div>
                </td>

                <!-- All -->
                <td class="td-actions text-right p-0">
                  <span *ngIf="timeTrack.loading" class="text-lavuro spinner-border spinner-border-sm mr-1"></span>
                  <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                    *ngIf="!timeTrack.loading" [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                    <i class="material-icons">more_vert</i>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="completeClockInOutConfirm(timeTrack)">
                      <span>Completar Fichaje</span>
                    </button>
                    <!-- <button mat-menu-item (click)="openNewTimeTrackModal(timeTrack)">
                      <span>Ver Mapa</span>
                    </button> -->
                    <button mat-menu-item (click)="openDeleteTimeTrackConfirm(timeTrack.timetracks)"
                      *ngIf="!timeTrack.loading && isDev">
                      <span>Eliminar</span>
                    </button>
                  </mat-menu>
                </td>
              </tr>
            </ng-container>

            <!-- All -->
            <tr *ngIf="thereAreMore && !loading">
              <td colspan="10">
                <button class="btn btn-link text-purple-manax text-capitalize p-0" (click)='loadMore()'>+ cargar
                  mas</button>
              </td>
            </tr>
            <tr *ngIf="loading">
              <td colspan="10" class="text-center">
                <div class="d-flex justify-content-center">
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot class="text-purple-manax">
            <tr *ngIf="!loading">
              <td colspan="10">
                <div class="row">
                  <div class="col-md-12">
                    Mostrando: {{ timeTracks.length }} Fichajes
                  </div>
                </div>
              </td>
            </tr>
          </tfoot>
        </table>
        <!-- </div>
          </div>
        </div> -->
        <div class="row d-flex justify-content-center align-items-center" *ngIf="showBanner && !loading">
          <div class="col-10 col-md-10 bg-banner pt-1 pb-0">
            <div class="row">
              <div class="col-2 ml-auto text-right">
                <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                  (click)="deleteBanner()">
                  <i class="material-icons">close</i>
                </button>
              </div>
            </div>
            <div class="row  px-5">
              <div
                class="col-12 col-sm-6 col-md-2 order-3 order-md-1  order-sm-2 d-flex align-items-center justify-content-center p-0">
                <img src="/assets/img/phone-banner.png" style="width: 100%; min-width: 125px;">
              </div>
              <div class="col-12 col-md-8 order-md-2 order-sm-1 d-flex flex-column justify-content-center px-md-4">
                <h5 class="text-center title-banner">¿Tus trabajadores ya tienen la app de Manax?</h5>
                <p class="paragraph-banner">Desde la app de Manax los trabajadores pueden acceder a su <b>agenda</b> de
                  trabajos asignados, realizar
                  <b>fichajes</b> geolocalizados, subir <b>fotos, reportes, incidencias</b> y también cargar
                  <b>materiales</b> que se hayan
                  utilizado en el trabajo.
                </p>
              </div>
              <div
                class="col-12 col-sm-6 col-md-2 order-2 order-md-3 order-sm-3 d-flex flex-column align-items-center justify-content-center">
                <button mat-raised-button type="button" (click)="openWhatsapp()"
                  class="btn btn-600 btn-manax buttons-banner">
                  Enviar link <i class="fa fa-whatsapp" style="font-weight: 500 !important;"></i>
                </button>
                <a mat-raised-button type="button" href="https://manax.page.link/descarga"
                  class="btn btn-600 btn-manax buttons-banner">
                  Descargar <i class="material-icons"
                    style="color: white; font-weight: 500 !important;">download_for_offline</i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>